import React from 'react';

const PRIVACY_POLICY_URL = 'https://www.angkas.com/privacy-policy';

function PrivacyPolicyLink() {
  return (
    <a
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="privacy-link"
      aria-label="Read our Privacy Policy (opens in new tab)"
    >
      Privacy Policy
    </a>
  );
}

export default function PrivacyPolicyMessage({daxMode, caxMode}) {
  const text = caxMode && !daxMode ? (
    <>
      Private & Secure. By chatting, you agree to our{' '}
      <PrivacyPolicyLink />
      .
    </>
  ) : (
    <>
      Ang chat na ito ay private, Sa paggamit nito, sumasang-ayon ka sa aming{' '}
      <PrivacyPolicyLink />
      .
    </>
  );

  return (
    <div id="privacy-policy-message" aria-label="Privacy Policy Notice">
      <div className="privacy-policy-content">
        <span className="privacy-text">{text}</span>
      </div>
    </div>
  );
}
